import { render, staticRenderFns } from "./jlzz.vue?vue&type=template&id=9c0dc556&scoped=true"
import script from "./jlzz.vue?vue&type=script&lang=js"
export * from "./jlzz.vue?vue&type=script&lang=js"
import style0 from "./jlzz.vue?vue&type=style&index=0&id=9c0dc556&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0dc556",
  null
  
)

export default component.exports